<template lang="pug">
  .details
    .detail(v-for="(detail, index) in details" :key="index")
      .header.columns
        h6.title.column {{ detail.layer.nomeDato }}
        div.column.view-map(@click="toggleMap(detail)" v-if="existLayer(detail)")
          div(v-if="detail.hidden")
            icon-base(width="25" height="25" icon-name="Mostra layer" iconColor="#0567b3")
              icon-eye
          div(v-else)
            icon-base(width="25" height="25" icon-name="Nascondi layer" iconColor="#0567b3")
              icon-eye-disabled
      table
        tr(v-for="(value, index) in detail.features" :key="index" :class="{active: !detail.hidden}")
          td {{ value.nome }}
</template>

<script>
import IconBase from '@/components/IconBase'
import IconEye from '@/components/icons/IconEye'
import IconEyeDisabled from '@/components/icons/IconEyeDisabled'
import { loadModules } from 'esri-loader'
export default {
  name: 'CharacterizationItem',
  components: {
    IconBase,
    IconEye,
    IconEyeDisabled
  },
  props: {
    title: {
      type: String,
      default: 'No title'
    },
    details: {
      type: Array
    }
  },
  computed: {
    webCartLayer () {
      return this.$store.state.webCartLayer
    }
  },
  mounted: function () {
    this.init()
  },
  methods: {
    init () {
      // code
      console.log('details', this.details)
    },
    toggleMap (layer) {
      this.$store.commit('SET_TOGGLE_CHARACTERIZATION', layer)
      let mapLayer = this.webCartLayer.allSublayers.find(sublayer => sublayer.title === layer.layer.webgisLayer)

      loadModules(
        [
          'esri/layers/FeatureLayer'
        ],
        { url: this.$store.state.config.arcgis }
      ).then(
        ([
          FeatureLayer
        ]) => {
          let _this = this

          let layerx = new FeatureLayer({
            url: _this.$store.state.config.MapServer.url + mapLayer.id
          })

          if (typeof _this.$store.state.map.layers.items.find((item) => item.layerId === mapLayer.id) === 'undefined') {
            _this.$store.state.map.add(layerx)
          } else {
            _this.$store.state.map.layers.items.find((x) => x.layerId === layerx.layerId).visible = !_this.$store.state.map.layers.items.find((x) => x.layerId === layerx.layerId).visible
          }
        })
      // mapLayer.visible = !mapLayer.visible
    },
    existLayer (layer) {
      let mapLayer = this.webCartLayer.allSublayers.find(sublayer => sublayer.title === layer.layer.webgisLayer)
      if (mapLayer) return true
      else return false
    }
  }
}
</script>

<style lang="scss" scoped>
.details {
  background-color: #fafafa;
}
.detail {
  font-size: .8em;
  padding-bottom: 1em;
  tr.active {
    background-color: darken(#f3f3f3, 3%)
  }
  tr td {
    padding: 0.9rem 4rem
  }
  table tr:last-child td {
    border: 0;
  }
}
.header {
  padding: .2em 0;
  margin-bottom: 0;
  background-color: #f3f3f3;
  * {
    color: #333333;
  }
  h6 {
    display: flex;
    align-items: center;
    margin-bottom: 0;
    padding-left: 5.5em;
    text-transform: uppercase;
  }
  div {
    cursor: pointer;
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .view-map {
    color: $link;
    svg {
      margin: 0 2.2em 0 1.5em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CharacterizationItem.vue